import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <div className="Footer">
      <p>© Flo aux VVC</p>
    </div>
  );
};

export default Footer;
